import { Icon, IconButton, Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { dashboardCardSx } from "../constants";

function ThresholdDialog({ row, onClose }) {
  const thresholdRows = row
    ? [
      ["Fresh Water", row.fresh.threshold ? `${row.fresh.threshold}%` : "N/A"],
      ["Waste Water", row.waste.threshold ? `${row.waste.threshold}%` : "N/A"],
      ["Waste Water 2", row.waste2.threshold ? `${row.waste2.threshold}%` : "N/A"],
      ["Waste Water 3", row.waste3.threshold ? `${row.waste3.threshold}%` : "N/A"],
      ["Men Temp", row.menTemp.threshold ? `${row.menTemp.threshold}F` : "N/A"],
      ["Women Temp", row.womenTemp.threshold ? `${row.womenTemp.threshold}F` : "N/A"],
      ["Utility Temp", row.utilityTemp.threshold ? `${row.utilityTemp.threshold}F` : "N/A"],
    ]
    : [];

  return (
    <Dialog
      open={Boolean(row)}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          ...dashboardCardSx,
          color: "#fff",
        },
      }}
    >
      <DialogTitle>
        <MDBox display="flex" alignItems="center" justifyContent="space-between">
          <MDTypography variant="h6" color="white" fontWeight="bold">
            {row?.name || "Device"} Thresholds
          </MDTypography>
          <IconButton onClick={onClose} size="small" sx={{ color: "#fff" }}>
            <Icon>close</Icon>
          </IconButton>
        </MDBox>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          {thresholdRows.map(([label, value]) => (
            <MDBox
              key={label}
              display="flex"
              justifyContent="space-between"
              p={1.25}
              borderRadius="md"
              sx={{ backgroundColor: "rgba(26, 32, 53, 0.65)", border: "1px solid rgba(255, 255, 255, 0.08)" }}
            >
              <MDTypography variant="button" color="white">
                {label}
              </MDTypography>
              <MDTypography variant="button" color="white" fontWeight="bold">
                {value}
              </MDTypography>
            </MDBox>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ThresholdDialog;